import { db } from "../firebase/firebase";
import { collection, getDocs } from "firebase/firestore";

export async function loadBlogAnalytics(days = 30) {
  const blogsSnap = await getDocs(collection(db, "blogs"));
  const analyticsSnap = await getDocs(collection(db, "blogAnalytics"));

  const analyticsMap = {};
  analyticsSnap.forEach((doc) => {
    analyticsMap[doc.id] = doc.data();
  });

  const merged = blogsSnap.docs.map((d) => {
    const data = d.data();
    const a = analyticsMap[d.id] || {};

    return {
      id: d.id,
      ...data,
      views: a.views || 0,
      likes: a.likes || 0,
      lastViewed: a.lastViewed || null,
      lastLiked: a.lastLiked || null,
    };
  });

  return merged;
}
